var React = require('react');

function Stop (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"28","cy":"28","r":"28","fill":"#CF1B1B","key":0}),React.createElement("rect",{"x":"17","y":"17","width":"22","height":"22","rx":"1","fill":"white","key":1})]);
}

Stop.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = Stop;

Stop.default = Stop;
